module.exports = __webpack_public_path__ + "static/Two Chairs-3c4ecae1220bc6aaa8fca992ab80cd8b.jpg";